<template>
  <div class="statement-react">
    <remove-button v-bind:statement="statement" @toggleOn="removeFormStatement(statement)" />
  </div>
</template>

<script>
  import StatementRemove from "./StatementRemove.ts";

  export default StatementRemove;
</script>
